export default __webpack_public_path__ + "static/media/icon-fleche-blanc.c066a671.svg";